import React from 'react';
import { Phone, ClipboardCheck, Settings, Headphones } from 'lucide-react';

const Process = () => {
  const steps = [
    {
      number: '01',
      icon: Phone,
      title: 'Contact Us',
      description: 'Reach out via phone, email, or our website. Our team is ready to assist you 24/7.'
    },
    {
      number: '02',
      icon: ClipboardCheck,
      title: 'Site Inspection',
      description: 'Our expert technicians visit your location for a thorough assessment and requirement analysis.'
    },
    {
      number: '03',
      icon: Settings,
      title: 'Installation / Repair',
      description: 'Professional installation or repair work completed efficiently with minimal disruption.'
    },
    {
      number: '04',
      icon: Headphones,
      title: 'After-Service Support',
      description: 'Ongoing support and maintenance to ensure your AC performs optimally year-round.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-primary font-semibold text-sm uppercase tracking-wider">Our Process</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            How We Work
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A streamlined process designed to provide you with seamless service from start to finish.
          </p>
        </div>

        {/* Process steps */}
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Connecting line */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-16 left-[60%] w-full h-0.5 bg-gradient-to-r from-primary to-sky-blue opacity-30"></div>
                )}
                
                <div className="relative text-center space-y-4 group">
                  {/* Number badge */}
                  <div className="inline-block mb-4">
                    <div className="relative">
                      <div className="text-7xl font-bold text-gray-100 group-hover:text-sky-blue/20 transition-colors">
                        {step.number}
                      </div>
                      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                        <div className="bg-white border-4 border-primary p-4 rounded-2xl shadow-lg group-hover:scale-110 group-hover:shadow-xl transition-all duration-300">
                          <step.icon className="text-primary" size={32} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mt-8">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Additional info */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-sky-blue/10 border border-primary/20 rounded-2xl p-8 max-w-3xl">
            <p className="text-lg text-gray-700 leading-relaxed">
              <span className="font-bold text-primary">Fast & Reliable:</span> Our streamlined process ensures quick turnaround times without compromising quality. From initial contact to after-service support, we're committed to exceeding your expectations.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
